import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueI18n from 'vue-i18n';

import App from '@/App';
import router from '@/router';
import store from '@/store';
import messages from '@/lang/';

// Plugins
import Util from '@/lib/util';
import Filter from '@/lib/filter';
import Message from '@/lib/message';
import Modal from '@/lib/modal';
import Service from '@/lib/service';
import Storage from '@/lib/storage';

// i18n config
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'es',
  messages
});

Vue.use(Storage, { appName: 'apostilla-web' });
Vue.use(VeeValidate);
Vue.use(Util);
Vue.use(Filter);
Vue.use(Message);
Vue.use(Modal);
Vue.use(Service, {
  apiUrl: process.env.API_URL
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js